<template>
    <div class="m-2">
        <div class="d-flex w-100 ps-3 pe-3" style="height: 80vh;">
            <div class="d-flex flex-column flex-wrap teacher_tool_box p-2 fs-5 pt-4 pb-4">
                <button class="btn_tool_box_tool"><i class="fas fa-camera"></i></button>
                <button class="btn_tool_box_tool"><i class="fas fa-volume-up"></i></button>
                <button class="btn_tool_box_tool"><i class="far fa-sticky-note"></i></button>
                <button class="btn_tool_box_tool"><i class="fas fa-highlighter"></i></button>
                <button class="btn_tool_box_tool"><i class="fas fa-font"></i></button>
                <button class="btn_tool_box_tool"><i class="fas fa-comment-dots"></i></button>
                <button class="btn_tool_box_tool">...</button>
            </div>
            <div class="flex-grow-1 ms-3" ref="main_center_div" style="overflow-x: scroll;">
              <!-- main video -->
              <div v-if="main_center_stream != null && !['vote', 'test'].includes(main_center_stream)" class="d-flex justify-content-center">
                <video autoplay playsinline :srcObject="main_center_stream" :muted="true"
                :height="$refs.main_center_div.offsetHeight"></video>
              </div>
              <!-- main vote -->
              <div v-else-if="main_center_stream == 'vote'" class="p-4 w-100 h-100">
                <div class="card w-100 h-100 main_center_vote p-4 text-white">
                  <h3>{{vote_data.topic}}</h3>
                  <div class="d-flex flex-wrap mt-2 justify-content-evenly">
                    <div class="vote_card position-relative"
                      v-for="(opt, i) in vote_data.option"
                      :key="i"
                    >
                      <div class="text border position-relative"
                      :class="{'selected': i == vote_data.selected_cursor}"
                      @click="vote_data.selected_cursor = i">
                        {{i+1}}. {{opt.text}}
                      </div>
                      <div class="image position-absolute top-0 start-0" 
                      v-if="opt.photo != null">
                        <el-image class="w-100 h-100" fit="cover" :src="opt.photo" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- main test -->
              <div v-else-if="main_center_stream == 'test'" class="p-4 w-100 h-100">
                <div class="card w-100 h-100 main_center_text p-4">
                  <h3>{{test_data.topic}}</h3>
                  <div class="d-flex flex-wrap h-100">
                    <div class="col-9">
                      <div v-if="test_data.option.length > 0">
                        <div class="d-flex flex-wrap fw-5">
                          <label class="fw-bold">Task {{test_data.selected_cursor + 1}}. </label>
                          <label>{{test_data.option[test_data.selected_cursor].text}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 d-flex flex-column pe-2">
                      <div class="d-flex fw-bold">
                        <div class="w-50 d-flex flex-wrap flex-column p-2" style="padding-top: 50px !important;">
                          <div class="test_option_card" v-for="opt, i in test_data.option" :key="i"
                          :class="{'selected': test_data.selected_cursor == i}" @click="test_data.selected_cursor = i"
                          v-show="(i+1) % 2 == 0">
                            {{i+1}}
                          </div>
                        </div>
                        <div class="w-50 d-flex flex-wrap flex-column p-2">
                          <div class="test_option_card" v-for="opt, i in test_data.option" :key="i"
                          :class="{'selected': test_data.selected_cursor == i}" @click="test_data.selected_cursor = i"
                          v-show="(i+1) % 2 != 0">
                            {{i+1}}
                          </div>
                        </div>
                      </div>
                      <div class="mt-auto text-center" style="cursor: pointer;">
                        <el-divider />
                        <h3 @click="main_center_stream = null">FINISH</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="video-list">
                <div v-for="item in videoList"
                  v-bind:video="item"
                  v-bind:key="item.id"
                  class="video-item position-relative bg-light">
                  <el-popover placement="left" width="auto" trigger="click" :key="`${item.id}_tool`"
                  v-if="item.peerID != null">
                    <template #reference>
                      <div>
                        <video autoplay playsinline :ref="el => { if (el) videos.push(el) }" height="160" :muted="item.muted" :id="item.id"></video>
                        <button class="btn position-absolute top-50 start-50 translate-middle" @click.stop="main_center_stream = item.stream">
                          <i class="fas fa-thumbtack"></i>
                        </button>
                      </div>
                    </template>
                    <div>
                      <button class="btn_good_job mt-2 d-flex align-items-center justify-content-center"
                      @click="to_student_single('good_job__', item.peerID)">Good Job</button>
                    </div>
                    <div>
                      <button class="btn_right mt-2 d-flex align-items-center justify-content-center"
                      @click="to_student_single('right_____', item.peerID)">Right</button>
                    </div>
                    <div>
                      <button class="btn_wrong mt-2 d-flex align-items-center justify-content-center"
                      @click="to_student_single('wrong_____', item.peerID)">Wrong</button>
                    </div>
                    <div>
                      <button class="btn_focus mt-2 d-flex align-items-center justify-content-center"
                      @click="to_student_single('focus_____', item.peerID)">Focus</button>
                    </div>
                    <div>
                      <button class="btn_edit mt-2 d-flex align-items-center justify-content-center"
                      @click="to_student_single('edit______', item.peerID)">Edit</button>
                    </div>
                  </el-popover>
                  <div v-else>
                    <video autoplay playsinline :ref="el => { if (el) videos.push(el) }" height="160" :muted="item.muted" :id="item.id"></video>
                    <button class="btn position-absolute top-50 start-50 translate-middle" @click.stop="main_center_stream = item.stream">
                      <i class="fas fa-thumbtack"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="d-flex fixed-bottom m-4 align-items-center">
            <button class="btn_hangout" @click="this.$router.push('/')"><i class="fas fa-phone-alt"></i></button>

            <el-popover placement="top" width="auto" trigger="click" popper-class="seat_plan_div">
              <template #reference>
                <button class="btn_oval ms-5">Seating Plan</button>
              </template>
              <div class="d-flex flex-wrap">
                <div class="d-flex flex-column justify-content-center align-items-center me-2 mb-2" v-for="i in 8" :key="i">
                  <div class="seat_plan_circle" :class="{'seat_plant_online': cube_number_online.includes(parseInt(i))}">
                  </div>
                  {{i}}
                </div>
              </div>
              <div class="d-flex flex-wrap">
                <div class="d-flex flex-column justify-content-center align-items-center me-2 mb-2" v-for="i in 8" :key="i">
                  <div class="seat_plan_circle" :class="{'seat_plant_online': cube_number_online.includes(parseInt(i)+8)}">
                  </div>
                  {{i+8}}
                </div>
              </div>
              <div class="d-flex flex-wrap">
                <div class="d-flex flex-column justify-content-center align-items-center me-2 mb-2" v-for="i in 8" :key="i">
                  <div class="seat_plan_circle" :class="{'seat_plant_online': cube_number_online.includes(parseInt(i)+16)}">
                  </div>
                  {{i+16}}
                </div>
              </div>
              <div class="d-flex flex-wrap">
                <div class="d-flex flex-column justify-content-center align-items-center me-2 mb-2" v-for="i in 8" :key="i">
                  <div class="seat_plan_circle" :class="{'seat_plant_online': cube_number_online.includes(parseInt(i)+24)}">
                  </div>
                  {{i+24}}
                </div>
              </div>
            </el-popover>
            <button class="btn_oval_dual_left ms-5" @click="setMyVideo()">
              <i class="fas fa-video me-2" v-if="myVideo"></i>
              <i class="fas fa-video-slash me-2" v-else></i>Camera
            </button>
            <button class="btn_oval_dual_right" @click="setMyAudio()">
              <i class="fas fa-microphone me-2" v-if="myAudio"></i>
              <i class="fas fa-microphone-slash me-2" v-else></i>Microphone
            </button>
            <button class="btn_share_screen ms-4" @click="shareScreen()"><i class="fas fa-desktop"></i></button>
            <button class="btn_circle ms-auto"><i class="far fa-smile"></i></button>
            <button class="btn_circle more ms-4" data-bs-toggle="modal" data-bs-target="#modal_interact_toolbox">...</button>
            <button class="btn_oval_dual_left ms-4"><i class="fas fa-user-alt me-2"></i>Participant</button>
            <button class="btn_oval_dual_right"><i class="far fa-comment-dots me-2"></i>Chat</button>
        </div>
        <div class="modal" tabindex="-1" id="modal_interact_toolbox" aria-hidden="true" data-bs-backdrop="false">
          <div class="modal-dialog interact_toolbox">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body d-flex flex-column">
                <button @click="to_student_all('signin____')" data-bs-dismiss="modal">Sign In</button>
                <button @click="to_student_all('class_bell')" data-bs-dismiss="modal">Class Bell</button>
                <button @click="to_student_all('answer_btn')" data-bs-dismiss="modal">Answer Button</button>
                <button @click="to_student_all('timing____')" data-bs-dismiss="modal">Timing</button>
                <button @click="to_student_all('grouping__')" data-bs-dismiss="modal">Grouping</button>
                <button @click="to_student_all('vote______')" data-bs-dismiss="modal">
                  <div class="w-100 h-100 text-center" data-bs-toggle="modal" data-bs-target="#vote_modal"
                  @click="reset_vote">
                    Vote
                  </div>
                </button>
                <button @click="to_student_all('test______')" data-bs-dismiss="modal">
                  <div class="w-100 h-100 text-center" data-bs-toggle="modal" data-bs-target="#test_modal"
                  @click="reset_test">
                    Test
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Vote Modal -->
        <div class="modal" tabindex="-1" id="vote_modal" data-bs-backdrop="false">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
              </div>
              <div class="modal-body">
                <div>
                  <input class="form-control w-100 border-bottom test_name" placeholder="Topic" v-model="vote_data.topic" />
                </div>
                <div class="d-flex flex-wrap w-100">
                  <div class="col-3 border-end">
                    <div class="d-flex flex-column pt-2">
                      <button class="my_option p-2" v-for="data, i in vote_data.option" :key="i" 
                      @click="vote_data.current_cursor = i"
                      :class="{'active': i == vote_data.current_cursor }">Option {{i+1}}</button>
                      <button class="my_option p-2 active mt-2"
                      @click="vote_data.option.push({
                      text: null, photo: null
                      })">+</button>
                    </div>
                  </div>
                  <div class="col-9 p-2" v-if="vote_data.option.length > 0">
                    <input class="form-control w-100 border-bottom question" placeholder="Question"
                    v-model="vote_data.option[vote_data.current_cursor].text" />
                    <div class="mt-2 ms-2">
                      <el-upload
                        action="#"
                        accept="image/*"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="(file)=>{
                          vote_data.option[vote_data.current_cursor].photo = upload_image(file);
                        }"
                      >
                        <template #default>
                          <button class="btn btn-light border">
                            Add Photo +
                          </button>
                        </template>
                      </el-upload>
                    </div>
                    <div class="mt-2" v-if="vote_data.option[vote_data.current_cursor].photo != null">
                      <el-image
                        :key="vote_data.current_cursor"
                        class="card"
                        :src="vote_data.option[vote_data.current_cursor].photo" 
                        :preview-src-list="[vote_data.option[vote_data.current_cursor].photo]"
                        width="50"
                        fit="contain"
                      />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-wrap w-100 mt-4">
                  <button type="button" class="btn btn-light border ms-auto"
                  data-bs-dismiss="modal" @click="main_center_stream = 'vote'">Start</button>
                  <button type="button" class="btn btn-secondary ms-2" data-bs-dismiss="modal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Test Modal -->
        <div class="modal" tabindex="-1" id="test_modal" data-bs-backdrop="false">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
              </div>
              <div class="modal-body">
                <div>
                  <input class="form-control w-100 border-bottom test_name" placeholder="Test Name" v-model="test_data.topic" />
                </div>
                <div class="d-flex flex-wrap w-100">
                  <div class="col-3 border-end">
                    <div class="d-flex flex-column pt-2">
                      <button class="my_option p-2" v-for="data, i in test_data.option" :key="i" 
                      @click="test_data.current_cursor = i"
                      :class="{'active': i == test_data.current_cursor }">Question {{i+1}}</button>
                      <button class="my_option p-2 active mt-2"
                      @click="test_data.option.push({
                      text: null, photo: null
                      })">+</button>
                    </div>
                  </div>
                  <div class="col-9 p-2" v-if="test_data.option.length > 0">
                    <input class="form-control w-100 border-bottom question" placeholder="Question"
                    v-model="test_data.option[test_data.current_cursor].text" />
                    <div class="mt-2 ms-2">
                      <el-upload
                        action="#"
                        accept="image/*"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="(file)=>{
                          test_data.option[test_data.current_cursor].photo = upload_image(file);
                        }"
                      >
                        <template #default>
                          <button class="btn btn-light border">
                            Add Photo +
                          </button>
                        </template>
                      </el-upload>
                    </div>
                    <div class="mt-2" v-if="test_data.option[test_data.current_cursor].photo != null">
                      <el-image
                        :key="test_data.current_cursor"
                        class="card"
                        :src="test_data.option[test_data.current_cursor].photo" 
                        :preview-src-list="[test_data.option[test_data.current_cursor].photo]"
                        width="50"
                        fit="contain"
                      />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-wrap w-100 mt-4">
                  <button type="button" class="btn btn-light border ms-auto"
                  data-bs-dismiss="modal" @click="main_center_stream = 'test'">Start</button>
                  <button type="button" class="btn btn-secondary ms-2" data-bs-dismiss="modal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  const io = require("socket.io-client");
  const SimpleSignalClient = require('simple-signal-client');
  const bootstrap = require('bootstrap');
  import { h } from 'vue'
  import { ElMessage } from 'element-plus'

  export default {
    name: 'InClassTeacher',
    components: {
    },
    beforeUpdate() {
      this.videos = []
    },
    data() {
      return {
        roomId: 'default-room',
        signalClient: null,
        localStream: null,
        videoList: [],
        canvas: null,
        socket: null,
        videos: [],
        myAudio: true,
        myVideo: true,
        student_button: [],
        at_quiz: false,
        quiz_data: {},
        socketURL: 'https://docker.yushan.tw',
        main_center_stream: null,
        screen_sharing: null,
        //msg box
        student_raise_hand_msg: null,
        // using in seat plan
        cube_number_online: [],
        //vote
        vote_data: {
          topic: null,
          current_cursor: 0,
          selected_cursor: null,
          option: [],
        },
        //test
        test_data: {
          topic: null,
          current_cursor: 0,
          selected_cursor: 0,
          option: [],
        }
      };
    },
    props: {
      enableLogs: {
        type: Boolean,
        default: true
      },
      peerOptions: {
        type: Object,  // NOTE: use these options: https://github.com/feross/simple-peer
        default() {
          return {};
        }
      },
      deviceId: {
        type: String,
        default: null
      }
    },
    watch: {
    },
    mounted() {
      /* var myModal = new bootstrap.Modal(document.getElementById('modal_interact_toolbox'), {
        backdrop: false
      })
      myModal.toggle() */
      const user_data = this.$store.state.user_data
      this.roomId = `${user_data.school}_${user_data.class}`
      console.log(this.roomId)
      this.join()
    },
    methods: {
      async join() {
        var that = this;
        console.log('join');
        this.socket = io.connect(this.socketURL, {path: "/socket/socket.io/" ,rejectUnauthorized: false, transports: ['websocket'],
        query: {user_id: this.$store.state.user_data._id} });
        this.signalClient = new SimpleSignalClient(this.socket);
        let constraints = {
          video: true,
          audio: true
        };
        if (that.deviceId) {
          constraints.video = { deviceId: { exact: that.deviceId } };
        }
        try {
          this.localStream = await navigator.mediaDevices.getUserMedia(constraints); 
          console.log('opened', this.localStream);
        } catch (error) {
          this.localStream = {id: 'no_mic_device'}
        }
        this.joinedRoom(this.localStream, true);
        this.signalClient.once('discover', (discoveryData) => {
          console.log('discovered', discoveryData)
          async function connectToPeer(peerID) {
            if (peerID == that.socket.id) return;
            try {
              console.log('Connecting to peer');
              const { peer } = await that.signalClient.connect(peerID, that.roomId, that.peerOptions);
              that.videoList.forEach(v => {
                if (v.isLocal) {
                  that.onPeer(peer, v.stream, peerID);
                }
              })
            } catch (e) {
              console.log(e)
              console.log('Error connecting to peer');
            }
          }
          discoveryData.peers.forEach((peerID) => connectToPeer(peerID));
          //that.$emit('opened-room', that.roomId);
        });
        this.signalClient.on('request', async (request) => {
          console.log('requested', request)
          const { peer } = await request.accept({}, that.peerOptions)
          console.log('accepted', peer);
          that.videoList.forEach(v => {
            if (v.isLocal) {
              that.onPeer(peer, v.stream, request.initiator);
            }
          })
        })
        this.signalClient.discover(that.roomId);
        this.register_socket_listener()
      },
      //------------------------------------------------------------------------------------
      register_socket_listener(){
        this.socket.on('cube_movement', data=>{
          //console.log(data);
          if('mode' in data && data['mode'] == 'return_speak'){
            ElMessage({
              showClose: true,
              duration: 0,
              message: `${data.name} raise his hand`
            })
          }
          if('mode' in data && data['mode'] == 'return_answer'){
            ElMessage({
              showClose: true,
              duration: 0,
              message: `${data.name} want to answer`
            })
          }
          if('mode' in data && data['mode'] == 'return_sign'){
            this.cube_number_online.push(parseInt(data.classNumber))
            ElMessage({
              showClose: true,
              duration: 0,
              message: `${data.name} is signin`
            })
          }
        })
      },
      //------------------------------------------------------------------------------------
      onPeer(peer, localStream, peerID=null) {
        var that = this;
        console.log('onPeer');
        console.log(localStream)
        if(localStream.id != "no_mic_device"){
          peer.addStream(localStream);
        }
        peer.on('stream', (remoteStream) => {
          that.joinedRoom(remoteStream, false, peerID);
          peer.on('close', () => {
            var newList = [];
            that.videoList.forEach(function (item) {
              if (item.id !== remoteStream.id) {
                newList.push(item);
              }
            });
            that.videoList = newList;
            that.$emit('left-room', remoteStream.id);
          });
          peer.on('error', (err) => {
            console.log('peer error ', err);
          });
        });
      },
      //------------------------------------------------------------------------------------
      joinedRoom(stream, isLocal, peerID) {
        var that = this;
        let found = that.videoList.find(video => {
          return video.id === stream.id
        })

        if (found === undefined) {
          let video = {
            id: stream.id,
            muted: isLocal,
            stream: stream,
            isLocal: isLocal,
            peerID: peerID
          };

          that.videoList.push(video);

          // Set main_center_stream 
          if(stream.main_stream != undefined && stream.main_stream == true){
            this.main_center_stream = stream
          }
        }

        setTimeout(function () {
          for (var i = 0, len = that.videos.length; i < len; i++) {
            if (that.videos[i].id === stream.id && stream.id != "no_mic_device") {
              that.videos[i].srcObject = stream;
              break;
            }
          }
        }, 500);
        
        //that.$emit('joined-room', stream.id);
      },
      //------------------------------------------------------------------------------------
      leave() {
        this.videoList.forEach(v => {
          try{
            v.stream.getTracks().forEach(t => t.stop())
          }
          catch(error){

          }
        });
        this.videoList = [];
        this.signalClient.peers().forEach(peer => peer.removeAllListeners())
        this.signalClient.destroy();
        this.signalClient = null;
        this.socket.destroy();
        this.socket = null;
      },
      //------------------------------------------------------------------------------------
      async shareScreen() {
        var that = this;
        if (navigator.mediaDevices == undefined) {
          console.log('Error: https is required to load cameras');
          return;
        }
        if(this.screen_sharing == null){
          try {
            var screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false });
            this.screen_sharing = screenStream.id
            this.joinedRoom(screenStream, true);
            //that.$emit('share-started', screenStream.id);
            that.signalClient.peers().forEach(p => that.onPeer(p, screenStream, null));
          } catch (e) {
            console.log('Media error: ' + JSON.stringify(e));
          }
        }
        else{
          // Close Screen
          this.main_center_stream = null
          let index = 0
          for(var i in this.videoList){
            console.log(this.videoList[i])
            if(this.videoList[i].id == this.screen_sharing){
              index = 1
            }
          }
          this.videoList.splice(index, 1)
          this.screen_sharing = null
        }
      },
      //------------------------------------------------------------------------------------
      log(message, data) {
        if (this.enableLogs) {
          console.log(message);
          if (data != null) {
            console.log(data);
          }
        }
      },
      //------------------------------------------------------------------------------------
      setMyAudio(){
        this.myAudio = !this.myAudio
        this.localStream.getAudioTracks()[0].enabled = this.myAudio
      },
      //------------------------------------------------------------------------------------
      setMyVideo(){
        this.myVideo = !this.myVideo
        this.localStream.getVideoTracks()[0].enabled = this.myVideo
      },
      //------------------------------------------------------------------------------------
      close_student_raise_hand_msg(){
        if(this.student_raise_hand_msg!=null)
          this.student_raise_hand_msg.close()
      },
      //------------------------------------------------------------------------------------
      to_student_single(code, peerID){
        console.log(code, peerID)
        this.socket.emit('teacher_to_student_cube', {
          code: code,
          peerID: peerID
        })
      },
      //------------------------------------------------------------------------------------
      to_student_all(code){
        this.socket.emit('teacher_to_student_cube_all', {
          code: code,
        })
      },
      //------------------------------------------------------------------------------------
      // turn uplaod file to blob
      upload_image(file){
        console.log(file)
        return URL.createObjectURL(new Blob([file.raw]))
      },
      reset_vote(){
        this.vote_data.option.forEach(opt=>{
          if(opt.photo != null){
            // remove blob photo
            URL.revokeObjectURL(opt.photo)
          }
        })
        this.vote_data = {
          topic: null,
          current_cursor: 0,
          selected_cursor: null,
          option: [],
        }
      },
      reset_test(){
        this.test_data.option.forEach(opt=>{
          if(opt.photo != null){
            // remove blob photo
            URL.revokeObjectURL(opt.photo)
          }
        })
        this.test_data = {
          topic: null,
          current_cursor: 0,
          selected_cursor: 0,
          option: [],
        }
      }
    },
    async beforeRouteLeave (to, from , next) {
      const answer = await window.confirm('您要離開教室嗎')
      if (answer) {
        clearInterval(this.syncdata)
        this.leave()
        next()
      } else {
        next(false)
      }
    }

  };
</script>